import { c as _c } from "react/compiler-runtime";
import { ContactPanel } from "@/sanity/sanity.types";
import ContactInfo from "../utils/ContactInfo";
interface ContactPanelSectionProps {
  data: ContactPanel;
}
const ContactPanelSection = t0 => {
  const $ = _c(16);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.summary) {
    t1 = data.summary && <div className="mb-5"><strong className="text-[20px] leading-7 font-semibold text-black">{data.summary}</strong></div>;
    $[0] = data.summary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.hours) {
    t2 = data.hours && <p className="mb-5 text-[18px] leading-7 font-medium text-black">{data.hours}</p>;
    $[2] = data.hours;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.email || $[5] !== data.phone) {
    t3 = <ContactInfo phone={data.phone} email={data.email} />;
    $[4] = data.email;
    $[5] = data.phone;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="leading-6">{t1}{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== data.postal) {
    t5 = data.postal && <div><strong className="text-xl leading-7 font-semibold text-black">Postal Mail:</strong><p className="mt-[45px] text-[18px] font-medium text-black">{data.postal.line1 && <>{data.postal.line1}<br /></>}{data.postal.line2 && <>{data.postal.line2}<br /></>}{data.postal.city && data.postal.state && data.postal.zip && <>{data.postal.city}, {data.postal.state} {data.postal.zip}</>}</p></div>;
    $[11] = data.postal;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex flex-col gap-4 rounded-md border border-[#e5eaf4] bg-[#f6f6f6] p-8 md:gap-8 lg:flex-row lg:gap-20">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default ContactPanelSection;